module.exports = __webpack_public_path__ + "img/fleet.3e8005ec.png";